import { Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { memo } from "react";
import "./styles.scss";

type ErrorProps = {
  accountNumber: number;
  error: string;
  showHeader?: boolean;
  onBackButtonClicked?: () => void;
};

export const Error = memo(
  ({ accountNumber, error, showHeader, onBackButtonClicked }: ErrorProps) => {
    return (
      <>
        {showHeader && (
          <Row className="py-5 px-8 align-center title justify-space-between header-container bordered">
            <Row className="align-center">
              <Button
                shape="circle"
                icon={<ArrowLeftOutlined />}
                size="large"
                className="back-btn mr-6"
                onClick={onBackButtonClicked}
              />
              <h3 className="h h3 mr-8">
                <span className="desktop-label">Account:</span> {accountNumber}
              </h3>
            </Row>
          </Row>
        )}
        <Row className="account-tabs w-100 align-center justify-space-around">
          <span className="text-md title text-center">{error}</span>
        </Row>
      </>
    );
  },
);
